import { render, staticRenderFns } from "./NotificationPreview.vue?vue&type=template&id=020083c9&"
import script from "./NotificationPreview.vue?vue&type=script&lang=js&"
export * from "./NotificationPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020083c9')) {
      api.createRecord('020083c9', component.options)
    } else {
      api.reload('020083c9', component.options)
    }
    module.hot.accept("./NotificationPreview.vue?vue&type=template&id=020083c9&", function () {
      api.rerender('020083c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/NotificationPreview.vue"
export default component.exports